import { render, staticRenderFns } from "./NuveiCardViewGlobal.vue?vue&type=template&id=0cd583fd&"
import script from "./NuveiCardViewGlobal.vue?vue&type=script&lang=js&"
export * from "./NuveiCardViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports